import { createGlobalStyle, css } from 'styled-components';

const LoginPopupStyle = createGlobalStyle`${css`
	:root {
		--loginPopupSubtitleMargin: var(--sp4x) auto var(--sp8x);
		--loginPopupFormItemMarginTop: var(--sp6x);
		--loginPopupContentWrap: 0 var(--sp18x);
		--loginPopupForgotPasswordMarginTop: var(--sp2x);
		--loginPopupLowerButtonsWrapMarginTopBottom: var(--sp8x) 0 var(--sp8x) 0;
		--loginPopupSubtitleMaxWidth: var(--sp86x);
		--loginPopupContentContainerMaxWidth: var(--sp131x);
	}

	.popup-content-container {
		max-width: var(--loginPopupContentContainerMaxWidth) !important;
	}

	.login-popup-content-wrap {
		padding: var(--loginPopupContentWrap);

		.forgot-password {
			display: block;
			margin-left: auto;
			width: fit-content;
			cursor: pointer;
			margin-top: var(--loginPopupForgotPasswordMarginTop);
			border: none;
			outline: none;
			background: none;
			margin-top: var(--sp3x);
		}

		.sign-up {
			cursor: pointer;
		}

		.login-popup-title {
			text-align: center;
		}

		.login-popup-subtitle {
			margin: var(--loginPopupSubtitleMargin);
			text-align: center;
			max-width: var(--loginPopupSubtitleMaxWidth);
		}

		.login-popup-cont {
			.form-item {
				margin-top: var(--loginPopupFormItemMarginTop);

				.ant-form-item {
					margin-bottom: 0;
				}
			}
		}

		.lower-buttons-wrap {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: var(--loginPopupLowerButtonsWrapMarginTopBottom);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		:root {
			--loginPopupSubtitleMargin: var(--sp4x) auto var(--sp5x);
			--loginPopupFormItemMarginTop: var(--sp5x);
			--loginPopupContentWrap: 0 var(--sp13x);
			--loginPopupLowerButtonsWrapMarginTopBottom: var(--sp6x) 0 var(--sp6x) 0;
			--loginPopupSubtitleMaxWidth: var(--sp64x);
			--loginPopupContentContainerMaxWidth: var(--sp98x);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		:root {
			--loginPopupSubtitleMargin: var(--sp3x) auto var(--sp5x);
			--loginPopupFormItemMarginTop: var(--sp3x);
			--loginPopupContentWrap: 0 var(--sp10x);
			--loginPopupLowerButtonsWrapMarginTopBottom: var(--sp5x) 0 var(--sp5x) 0;
			--loginPopupSubtitleMaxWidth: var(--sp50x);
			--loginPopupContentContainerMaxWidth: var(--sp77x);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		:root {
			--loginPopupSubtitleMargin: var(--sp3x) auto var(--sp4x);
			--loginPopupFormItemMarginTop: var(--sp3x);
			--loginPopupContentWrap: 0 var(--sp9x);
			--loginPopupLowerButtonsWrapMarginTopBottom: var(--sp5x) 0 var(--sp5x) 0;
			--loginPopupSubtitleMaxWidth: var(--sp48x);
			--loginPopupContentContainerMaxWidth: var(--sp73x);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		:root {
			--loginPopupSubtitleMargin: var(--sp3x) auto var(--sp4x);
			--loginPopupFormItemMarginTop: var(--sp3x);
			--loginPopupContentWrap: 0 var(--sp7x);
			--loginPopupLowerButtonsWrapMarginTopBottom: var(--sp5x) 0 var(--sp5x) 0;
			--loginPopupSubtitleMaxWidth: var(--sp51x);
			--loginPopupContentContainerMaxWidth: var(--sp71x);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		:root {
			--loginPopupSubtitleMargin: var(--sp3x) auto var(--sp4x);
			--loginPopupFormItemMarginTop: var(--sp3x);
			--loginPopupContentWrap: 0 var(--sp5x);
			--loginPopupLowerButtonsWrapMarginTopBottom: var(--sp4x) 0 var(--sp5x) 0;
			--loginPopupSubtitleMaxWidth: var(--sp44x);
			--loginPopupContentContainerMaxWidth: var(--sp60x);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		:root {
			--loginPopupSubtitleMargin: var(--sp3x) auto var(--sp4x);
			--loginPopupFormItemMarginTop: var(--sp3x);
			--loginPopupContentWrap: 0 var(--sp5x);
			--loginPopupLowerButtonsWrapMarginTopBottom: var(--sp5x) 0 var(--sp5x) 0;
			--loginPopupSubtitleMaxWidth: 100%;
			--loginPopupContentContainerMaxWidth: var(--sp81x);
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		:root {
			--loginPopupSubtitleMargin: var(--sp3x) auto var(--sp4x);
			--loginPopupFormItemMarginTop: var(--sp3x);
			--loginPopupContentWrap: 0;
			--loginPopupForgotPasswordMarginTop: var(--sp1x);
			--loginPopupLowerButtonsWrapMarginTopBottom: var(--sp4x) 0 var(--sp5x) 0;
			--loginPopupSubtitleMaxWidth: 100%;
			--loginPopupContentContainerMaxWidth: calc(100% - 32px);
		}
	}
`}`;

export default LoginPopupStyle;
